import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AgentManagementListItemDto } from 'src/app/features/agent-management/models/agent-management-list-item.dto';

@Injectable({ providedIn: 'root' })
export class AgentQueueDialogService {
  private readonly _open$ = new Subject<AgentManagementListItemDto>();
  readonly open$ = this._open$.asObservable();

  private readonly _queuesSaved$ = new Subject<void>();
  readonly queuesSaved$ = this._queuesSaved$.asObservable();

  open(agent: AgentManagementListItemDto): void {
    this._open$.next(agent);
  }

  notifyQueuesSaved(): void {
    this._queuesSaved$.next();
  }
}
